export class PSCoordinacionProyectoModel {
  id: number = 0;
  idps: any = null;
  nHito: number = 1;
  descripcion: string = '';
  fechaPrevistaHito: Date | null = null;
}

